import { render, staticRenderFns } from "./adminCrmProjects.vue?vue&type=template&id=81dc97a4&scoped=true&"
import script from "./adminCrmProjects.vue?vue&type=script&lang=js&"
export * from "./adminCrmProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81dc97a4",
  null
  
)

export default component.exports